module.exports = __webpack_public_path__ + "school/img/campus_health_top_bg.87821609.png";